module.exports = __webpack_public_path__ + "img/a.5c5fedf6.jpg";